import { supabase } from "@baseline/web/supabase";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

export const CHAT_API_URL = `${supabaseUrl}/functions/v1/chat`;

export async function getChatHeaders(): Promise<Record<string, string>> {
	const {
		data: { session },
	} = await supabase.auth.getSession();
	if (!session?.access_token) {
		throw new Error("Not authenticated");
	}
	return {
		Authorization: `Bearer ${session.access_token}`,
		apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
	};
}
